import { Lightning } from '@lightningjs/sdk';
import { DEFAULT_MODE } from '@tornado-rdk/theme';
import { filledColor, emptyColor } from './heroOverlay.style';
import { identity, middle } from '../../utils/sizes';

export default class HeroOverlay extends Lightning.Component {
  static _template() {
    return {
      Left: {
        rect: true,
        w: v => v * 0.75,
        h: identity,
        colorBl: filledColor[DEFAULT_MODE],
        colorUl: filledColor[DEFAULT_MODE],
        colorUr: emptyColor[DEFAULT_MODE],
        colorBr: emptyColor[DEFAULT_MODE],
      },
      Bottom: {
        rect: true,
        w: identity,
        h: middle,
        mountY: 1,
        y: identity,
        colorBl: filledColor[DEFAULT_MODE],
        colorUl: emptyColor[DEFAULT_MODE],
        colorUr: emptyColor[DEFAULT_MODE],
        colorBr: filledColor[DEFAULT_MODE],
      },
    };
  }
}
